import { render, staticRenderFns } from "./SnackbarAction.pug?vue&type=template&id=b8cb013a&lang=pug&external"
import script from "./SnackbarAction.js?vue&type=script&lang=js&external"
export * from "./SnackbarAction.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports